<template>
  <v-row v-if="hasPointEvent">
    <v-col cols="7">
      <div class="text-body-1">{{ label }}: {{ value }}</div>
    </v-col>
    <v-col cols="5">
      <div class="text-body-1">{{ timestamp }}</div>
    </v-col>
  </v-row>
</template>

<script>
// import { RecIndividual } from '@/rec-cache/rec-cache-individual'

// import { Iris } from '@/rec-cache/rec-cache-types'

import dateFormat from 'dateformat'

export default {
  props: {
    pointEvents: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    hasPointEvent: function () {
      return (
        !!this.pointEvents.length &&
        !!this.pointEvents.filter((p) => !!p.event).length
      )
    },
    mostRecentEvent: function () {
      // TODO look over algorithm...
      const dates = this.pointEvents.map((p) => p.eventTime).filter((d) => !!d)
      console.log('DATES', dates)

      const [mostRecent] = dates.sort(
        (a, b) => new Date(b).toValue() - new Date(a).toValue()
      )
      console.log('MOST RECENT', mostRecent)

      return this.pointEvents.find((p) => p.eventTime == mostRecent)
    },
    label: function () {
      return this.mostRecentEvent?.pointName || 'no name'
    },
    value: function () {
      return this.mostRecentEvent?.eventValue || 'no value'
    },
    timestamp: function () {
      const date = this.mostRecentEvent?.eventDate
      if (date) {
        return dateFormat(date, 'yymmdd HH.MM')
      }
      return 'no date'
    },
    // TODO ...
    activeAlarm: function () {
      return false
    },
  },
  created: function () {
    // console.log('POINT EVENTS', this.label, this.pointEvents)
  },
}
</script>
